module.exports = __webpack_public_path__ + "img/CSD.5be01910.png";